/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import { assetImages } from "constants";

//custom arrow button for react carousel outside
const ButtonGroup = ({ next, previous }) => {
  return (
    <div className="partner_arws arws1">
      <button className={previous ? "" : "disable"} onClick={previous} />
      <button type="button" className="prev slick-arrow" onClick={previous}>
        <span className="material-icons-outlined">arrow_back</span>
      </button>
      <button type="button" className="next slick-arrow" onClick={next}>
        <span className="material-icons-outlined">arrow_forward</span>
      </button>
    </div>
  );
};

const Sponsors = () => {
  const eventId = localStorage.getItem("eventId");

  //custom property for responsive
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 980, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 500, min: 0 },
      items: 2,
    },
  };

  const glowCount = [1, 2, 3, 4, 5];
  const [activeTab, setactiveTab] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [partnerList, setPartnerList] = useState([]);

  //function for get all event members
  const getAllEventPartners = async (roleSlug) => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_ALL_EVENT_PARTNERS +
        `?event=${eventId}&isallparticipants=${true}&partnerroleslug=${roleSlug}`;

      const response = await getData(requestUrl);

      // console.log(response);
      setIsLoading(false);
      if (response.status) {
        setPartnerList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (eventId) {
      setactiveTab("organizer");
      getAllEventPartners("ORGANIZER");
    }
  }, []);

  return (
    <section className="sponsor_organize_area pd_70">
      <div className="container">
        <div className="page_hdng text-center mb-5">
          <h2 className="fs-xl text-uppercase">Sponsors & Organizers</h2>
        </div>

        {/* sponsor headings */}
        <div className="tab_links">
          <ul className="nav nav-tabs justify-content-center">
            <li className="nav-item">
              <button
                className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                  activeTab == "organizer" ? "active" : ""
                }`}
                onClick={() => {
                  setactiveTab("organizer");
                  getAllEventPartners("ORGANIZER");
                }}
              >
                ORGANIZER
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                  activeTab == "coorganizer" ? "active" : ""
                }`}
                onClick={() => {
                  setactiveTab("coorganizer");
                  getAllEventPartners("COORGANIZER");
                }}
              >
                CO-ORGANIZER
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                  activeTab == "academic" ? "active" : ""
                }`}
                onClick={() => {
                  setactiveTab("academic");
                  getAllEventPartners("ACADEMICPARTNER");
                }}
              >
                ACADEMIC PARTNER
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                  activeTab == "mediallies" ? "active" : ""
                }`}
                onClick={() => {
                  setactiveTab("mediallies");
                  getAllEventPartners("MEDIAALLIES");
                }}
              >
                MEDIA ALLIES
              </button>
            </li>
          </ul>
        </div>

        {/* sponsor list */}
        <div className="partner_slide_outer position-relative">
          {isLoading ? (
            <div className="partner_slider">
              <Carousel
                responsive={responsive}
                infinite
                arrows={false}
                renderButtonGroupOutside={false}
                customButtonGroup={<ButtonGroup />}
              >
                {glowCount.map((count, index) => {
                  return (
                    <div className="partner_slide_item" key={index}>
                      <div className="partner_bx bg_white text-center">
                        <Link
                          to="#"
                          className="partner_logo d-flex align-items-center justify-content-center placeholder placeholder-sm text-gray"
                        ></Link>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          ) : (
            <div className="partner_slider">
              <Carousel
                responsive={responsive}
                infinite
                arrows={false}
                renderButtonGroupOutside={partnerList.length > 4 ? true : false}
                customButtonGroup={<ButtonGroup />}
              >
                {partnerList.map((sponsor, index) => {
                  return (
                    <div className="partner_slide_item" key={index}>
                      <div className="partner_bx bg_white text-center">
                        <Link
                          to="#"
                          className="partner_logo d-flex align-items-center justify-content-center"
                        >
                          <img
                            src={
                              sponsor.image == ""
                                ? ""
                                : url.SERVER_URL + sponsor.image
                            }
                            alt=""
                          />
                        </Link>
                        <p>{sponsor.name}</p>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
